import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React, { useMemo } from 'react';
import './processingSummaryTableBilling.scss';

const COLUMN_CLASSES = [
    'pst-col pst-col--step',
    'pst-col pst-col--by',
    'pst-col pst-col--date',
    'pst-col pst-col--remarks',
];

const COLUMN_WIDTHS = ['30%', '20%', '28%', '22%'];

/** Activity log table for billing workflow popups only (DDE, INST, PP, ALB). */
const ProcessingSummaryTableBilling = (props) => {
    const data = useMemo(() => props.data, [props.data, props.type]);
    const columns = useMemo(() => props.columns, [props.columns, props.type]);
    const table = useReactTable({ data, columns, getCoreRowModel: getCoreRowModel() });

    return (
        <div className="processing-summary-table-container">
            <table className="table pst-table">
                <colgroup>
                    {COLUMN_WIDTHS.map((width, index) => (
                        <col key={index} className={COLUMN_CLASSES[index]} style={{ width }} />
                    ))}
                </colgroup>
                <thead className="thead">
                    {table.getHeaderGroups().map((headerGroup, rowIndex) => (
                        <tr key={rowIndex}>
                            {headerGroup.headers.map((header, colIndex) => (
                                <th
                                    key={header.id}
                                    className={COLUMN_CLASSES[colIndex]}
                                >
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody className="tbody">
                    {table.getCoreRowModel().rows.map((row, rowIndex) => (
                        <tr
                            key={row.id}
                            className={rowIndex % 2 === 0 ? 'pst-row pst-row--alt' : 'pst-row'}
                            onClick={() => {
                                if (typeof props.openDetailsPopUp !== 'function') return;
                                props.openDetailsPopUp(row.original.stepName ?? row.original);
                            }}
                        >
                            {row.getVisibleCells().map((cell, colIndex) => (
                                <td key={cell.id} className={COLUMN_CLASSES[colIndex]}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ProcessingSummaryTableBilling;
